import "./login.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap/";
import Logo from "./../../assets/HiFi-Red.svg";
import { TextField, Button } from "@mui/material";
import { TailSpin } from "react-loader-spinner";
import axios from "../../network/api";
import { baseUrl } from "../../network/constants/constants";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

function Login() {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });  
  const [serverError, setServerError] = useState("");
  const navigate = useNavigate();

  const handlePhone = (event) => {
    setPhone(event.target.value);
    setServerError(""); 
  };

  const validatePhone = (phone) => {
    const regex = /^(?:\+91\s?)?[6-9]\d{9}$/;
    setPhoneError(!regex.test(phone));
    return regex.test(phone);
  };


  const PostLogin = (props) => {
    setLoading(true);

    const payload = {
      phone: phone,
    };

    axios
      .post(baseUrl + "auth/business-admin-login/", payload)
      .then((response) => {
        setLoading(false);
        const dataToSend = { "phone": phone };
        navigate("../otp", { state: { data: dataToSend }, replace: true });
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.data?.message) {
          setSnackbar({
            open: true,
            message: error.response.data.message,
            severity: "error",
          });
        } else {
          console.error("Error occurred:", error);
        }
      });
  };

  return (
    <>
    <section id="login">
      <div className="content">
        <div className="brand-container">
          <img alt="logo" src={Logo} className="logo"/>
          <div className="business-name">HiFi Franchisee Admin Panel</div>
        </div>
        <Card className="login-card card mt-5 rounded-4">
          <div className="login-title">Login</div>

          <TextField
            id="phone"
            className="mt-4"
            label="Phone"
            variant="outlined"
            size="small"
            type="phone"
            value={phone}
            onChange={handlePhone}
            error={phoneError || !!serverError}
            helperText={phoneError ? "Invalid Mobile Number" : serverError || ""}
          />

          <Button
            variant="contained"
            className="login-btn mt-5 mb-3"
            onClick={() => {
              if (validatePhone(phone)) {
                setLoading(true);
                PostLogin();

              }
            }}
          >
            Submit
          </Button>
          <div className="spiner-container">
          <TailSpin
          className="mt-5"
            height="30"
            width="30"
            radius="1"
            color="#ff4d4d"
            ariaLabel="loading"
            visible={loading}
          />
          </div>
        </Card>
      </div>

      <a href="tel:" className="contact">ⓘ Contact Us</a>
    </section>
     <Snackbar
     open={snackbar.open}
     autoHideDuration={6000}
     onClose={() => setSnackbar({ ...snackbar, open: false })}
     anchorOrigin={{ vertical: "top", horizontal: "center" }}
   >
     <Alert
       onClose={() => setSnackbar({ ...snackbar, open: false })}
       severity={snackbar.severity}
       sx={{ width: "100%" }}
     >
       {snackbar.message}
     </Alert>
   </Snackbar>
   </>
  );
}

export default Login;
